<template>
    <div class="c-dynamic-form">
        <Request
                ref="request"
                :onRequestSuccess="requestSuccess"
                :onRequestError="requestError">
            <slot slot="body">
                <slot name="beforeForm"></slot>
                <CForm
                        v-if="dataFormStructure !== undefined && dataFormStructure.rows !== undefined"
                        ref="form"
                        @onSubmit="save"
                        @onReset="reset"
                        :options="options"
                        :structure="dataFormStructure">
                        <template v-for="row, rowIndex in dataFormStructure.rows">
                            <template v-for="col, colIndex in row.cols">
                                <template :form="form" v-if="col.cards !== undefined" :cards="col.cards">
                                    <slot v-for="card in col.cards" v-if="card.key !== ''" :slot="card.key">
                                        <slot :name="card.key"></slot>
                                    </slot>
                                </template>
                            </template>
                        </template>
                        <slot slot="afterForm">
                            <slot name="afterForm"></slot>
                        </slot>
                        <slot slot="beforeFormButtons">
                            <slot name="beforeFormButtons">
                                <b-button @click="onTrashClick" :class="options.trash.classes"  v-if="trashRoot !== '' && Core.Validation.isId(dataId) && options.trash !== undefined && options.trash.text !== undefined &&  options.trash.text !== ''" class="mr-2" type="button" :variant="options.trash.variant">
                                    {{options.trash.text}}
                                </b-button>
                            </slot>
                        </slot>
                        <slot slot="afterFormButtons">
                            <slot name="afterFormButtons"></slot>
                        </slot>
                        <slot slot="bottomForm">
                            <slot name="bottomForm"></slot>
                        </slot>
                </CForm>
            </slot>
        </Request>
    </div>
</template>
<script>
    import Request from './Request'
    import CForm from './CForm'
    import VueNotifications from 'vue-notifications'
    import miniToastr from 'mini-toastr'

    const toastTypes = {
        success: 'success',
        error: 'error'
    }

    miniToastr.init({types: toastTypes})

    export default {
        name: 'DynamicForm',
        components: {
            Request,
            CForm,
            VueNotifications
        },
        props: {
            ignoreRouteParamId: {
                type: Boolean,
                default: false
            },
            value: {
                type: String | Number,
                default: ''
            },
            getRoot: {
                type: String,
                default: ''
            },
            saveRoot: {
                type: String,
                default: ''
            },
            trashRoot: {
                type: String,
                default: ''
            },
            options: {
                type: Object,
                default: function () {
                    return {
                        submit: {
                            text: 'Enregistrer',
                            variant: 'success'
                        },
                        reset: {
                            text: 'Réinitialiser',
                            variant: 'light'
                        },
                        trash: {
                            text: 'Supprimer',
                            variant: 'danger'
                        }
                    }
                }
            },
            formStructure: {
                type: Object,
                default: function () {
                    return {
                    }
                }
            },
            saveAddArgs: {
                type: Function,
                default: function() {
                    return []
                }
            },
            initAddArgs: {
                type: Function,
                default: function() {
                    return []
                }
            },
            onSave: {
                type: Function,
                default: function() {
                    return true
                }
            },
            validation: {
                type: Function,
                default: function() {
                    return true
                }
            }
        },
        watch: {
            value(val) {
                this.dataId = val
            },
            dataId(val) {
                this.$emit('input', val)
            },
            '$route.params.id': {
                handler(val) {
                    this.dataId = val
                    this.init(val)
                }
            }
        },
        mounted() {
            let id = ''

            if (this.ignoreRouteParamId === false && this.$route !== undefined && Core.Validation.isId(this.$route.params.id)) {
                id = this.$route.params.id
            } else if (Core.Validation.isId(this.value)) {
                id = this.value
            }

            this.init(id)

            if (this.formStructure.rows!==undefined) {
                this.dataFormStructure = this.formStructure
            }
        },
        data: function () {
            return {
                Core: window.Core,
                dataId: '',
                dataFormStructure: [],
                dataSaveAddArgs: []
            }
        },
        computed: {
            form() {
                return this.$refs.form.data().form
            },
            fieldRefs() {
                return this.$refs.form.data().fieldRefs
            }
        },
        methods: {
            init(id) {
                this.$refs.request.setRoot(this.getRoot)
                this.$refs.request.setMethod('GET')
                this.$refs.request.clearArgs()

                if (this.$refs.form !== undefined) {
                    this.$refs.form.reset()
                }

                this.dataId = id
                if (Core.Validation.isId(id)) {
                    this.$refs.request.addArg('id', id)
                }

                let addArgs = this.initAddArgs()
                for(let addArgIndex in addArgs) {
                    let addArg = addArgs[addArgIndex]
                    if (!Core.Validation.isEmpty(addArg.key)&&addArg.value !== undefined) {
                        this.$refs.request.addArg(addArg.key, addArg.value, addArg.type)
                    }
                }

                this.$emit('onInit', this.dataId)

                this.$refs.request.request()
            },
            onTrashClick() {
                this.$emit('onTrashClick', this.dataId)
            },
            addSaveArg(key, value, type) {
                this.dataSaveAddArgs.push({
                    key: key,
                    value: value,
                    type: type
                })
            },
            clearSaveArgs() {
                this.dataSaveAddArgs = []
            },
            save(form, fieldRefs, structure) {

                this.$refs.form.securityBlock = true

                if (this.validation(form, fieldRefs, structure)) {
                    this.$emit('isValid', true)

                    this.$refs.request.setRoot(this.saveRoot)

                    if (Core.Validation.isId(this.dataId) || (form.id !== undefined && Core.Validation.isId(form.id))) {
                        this.$refs.request.setMethod('PUT')
                    } else {
                        this.$refs.request.setMethod('POST')
                    }

                    this.$emit('onSave', form, fieldRefs, structure)

                    for(let key in form) {
                        let field = Core.Array.findByKey(this.dataFormStructure.fields, 'id', key)
                        let value = form[key]
                        this.$refs.request.addArg(key, value, field.type)
                    }

                    let addArgs = this.saveAddArgs(form)
                    for(let addArgIndex in addArgs) {
                        let addArg = addArgs[addArgIndex]
                        if (!Core.Validation.isEmpty(addArg.key)&&addArg.value !== undefined) {
                            this.$refs.request.addArg(addArg.key, addArg.value, addArg.type)
                        }
                    }

                    addArgs = this.dataSaveAddArgs
                    for(let addArgIndex in addArgs) {
                        let addArg = addArgs[addArgIndex]
                        if (!Core.Validation.isEmpty(addArg.key)&&addArg.value !== undefined) {
                            this.$refs.request.addArg(addArg.key, addArg.value, addArg.type)
                        }
                    }

                    this.$emit('onSaveRequest', form, fieldRefs, structure)

                    this.$refs.request.request()
                } else {
                    this.$emit('isValid', false)
                }

            },
            reset(form, fieldRefs, structure) {
            },
            trash() {
                if (Core.Validation.isId(this.dataId)) {
                    this.$refs.request.setRoot(this.trashRoot)
                    this.$refs.request.setMethod('DELETE')

                    this.$refs.request.addArg('id', this.dataId)

                    this.$emit('onTrash', this.dataId)

                    this.$refs.request.request()
                }
            },
            requestSuccess(data) {


                if (undefined !== data.formStructure) {
                    this.dataFormStructure = data.formStructure
                }

                if (data.id !== undefined) {
                    this.dataId = data.id.toString()
                    this.$refs.form.setValue('id', data.id.toString())

                    // Initialise l'ID de l'instance si le component détient l'option
                    for(let fieldRef in this.$refs.form.fieldRefs) {
                        let field = Core.Array.findByKey(this.dataFormStructure.fields, 'id', fieldRef)
                        if (field.type === Core.Value.typePayments) {
                            if (this.$refs.form !== undefined && this.$refs.form.fieldRefs !== undefined && this.$refs.form.fieldRefs[fieldRef].instanceId !== undefined) {
                                this.$refs.form.fieldRefs[fieldRef].instanceId = data.id.toString()
                            }
                        }
                    }
                }

                if (undefined !== data.selectOptions) {
                    this.setSelectOptions(data.selectOptions)
                }

                if (data.form !== undefined) {
                    for(let key in data.form) {
                        if (key !== '') {
                            let value = data.form[key]
                            let field = Core.Array.findByKey(this.dataFormStructure.fields, 'id', key)
                            if (field.type !== undefined) {

                                let selectOptions = []
                                if (data.selectOptions !== undefined) {
                                    if (data.selectOptions[key] !== undefined) {
                                        selectOptions = data.selectOptions[key]
                                    }
                                }
                                value = Core.Value.encode(value, field.type, selectOptions)
                                this.$refs.form.setValue(key, value)
                            }
                        }
                    }
                }

                this.$emit('onRequestSuccess', data, this.$refs.request.getMethod().toUpperCase())
                if (this.$refs.request.getMethod().toUpperCase() === 'POST' || this.$refs.request.getMethod().toUpperCase() === 'PUT') {
                    if (data.error === undefined) {
                        this.$emit('onSaveSuccess', data)
                    } else {
                        this.$emit('onSaveError', data)
                    }
                    if (data.alert !== undefined&&data.alert.variant!==undefined&&data.alert.message!==undefined) {
                        miniToastr[data.alert.variant](data.alert.message, '', 3000)
                    }
                }
                if (this.$refs.request.getMethod().toUpperCase() === 'DELETE') {
                    if (data.error === undefined) {
                        this.$emit('onTrashSuccess', data)
                    } else {
                        this.$emit('onTrashError', data)
                    }
                }
                if (this.$refs.request.getMethod().toUpperCase() === 'GET') {
                    if (data.error === undefined) {
                        this.$emit('onInitSuccess', data)
                    } else {
                        this.$emit('onInitError', data)
                    }
                }

                this.$refs.form.securityBlock = false
            },
            requestError(data) {
            },
            setSelectOptions(selectOptions) {
                if (this.$refs.form !== undefined) {
                    if (this.$refs.form.fieldRefs !== undefined) {
                        let formFieldRefs = this.$refs.form.fieldRefs
                        for(let optionKey in selectOptions) {
                            for(let fieldRefKey in formFieldRefs) {
                                if(optionKey === fieldRefKey) {
                                    if (selectOptions[optionKey] !== undefined) {
                                        if (this.$refs.form.fieldRefs[fieldRefKey] !== undefined) {
                                            this.$refs.form.fieldRefs[fieldRefKey].setOptions(selectOptions[optionKey])
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</script>

